
function ScrollArrowIcon({ className }) {
    return (
        <div className={className}>
        <img src='/imgs/_icons/scroll-arrow.svg' alt=""/>
    </div>
    )
}

export default ScrollArrowIcon